var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreyhounds(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10002_5242)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.0625 2.30786C8.5 3.65161 8.0625 5.02661 7.03125 5.33911C6.03125 5.68286 4.84375 4.87036 4.40625 3.52661C3.96875 2.18286 4.40625 0.807861 5.4375 0.495361C6.4375 0.151611 7.625 0.964111 8.0625 2.30786ZM4.125 5.62036C4.71875 6.62036 4.5625 7.80786 3.8125 8.24536C3.03125 8.68286 1.9375 8.21411 1.34375 7.21411C0.75 6.18286 0.90625 5.02661 1.65625 4.58911C2.4375 4.15161 3.53125 4.62036 4.125 5.62036ZM3.15625 11.9641C4.78125 7.52661 7.6875 6.40161 9 6.40161C10.2812 6.40161 13.1875 7.52661 14.8125 11.9641C14.9375 12.2454 15 12.5891 15 12.9016V12.9641C15 13.7766 14.3438 14.4016 13.5312 14.4016C13.1562 14.4016 12.8125 14.3704 12.4688 14.2766L9.71875 13.5891C9.25 13.4641 8.75 13.4641 8.25 13.5891L5.5 14.2766C5.15625 14.3704 4.8125 14.4016 4.4375 14.4016C3.625 14.4016 3 13.7766 3 12.9641V12.9016C3 12.5891 3.03125 12.2454 3.15625 11.9641ZM14.1562 8.24536C13.4062 7.80786 13.25 6.62036 13.8438 5.62036C14.4375 4.62036 15.5312 4.15161 16.3125 4.58911C17.0625 5.02661 17.2188 6.18286 16.625 7.21411C16.0312 8.21411 14.9375 8.68286 14.1562 8.24536ZM10.6875 5.33911C9.65625 5.02661 9.21875 3.65161 9.65625 2.30786C10.0938 0.964111 11.2812 0.151611 12.2812 0.495361C13.3125 0.807861 13.75 2.18286 13.3125 3.52661C12.875 4.87036 11.6875 5.68286 10.6875 5.33911Z",
    fill: "currentColor",
    fillOpacity: 1,
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10002_5242",
    x: 0.75,
    y: 0.151611,
    width: 16.4688,
    height: 15.25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10002_5242"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10002_5242",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyhounds);
export default ForwardRef;